import Flickity from 'flickity';

export default class TimelineCarousel {
  constructor() {
    this.$el = document.querySelector('.js-timeline');
    if (!this.$el) return;

    this.$carousel = this.$el.querySelector('.js-timeline-carousel');
    this.$nextButton = this.$el.querySelector('.js-timeline-next');
    this.$previousButton = this.$el.querySelector('.js-timeline-prev');
    this.$yearsButtons = this.$el.querySelectorAll('.js-timeline-year');
    this.$yearMobile = this.$el.querySelector('.js-timeline-year-mobile');

    this.carousel = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
    });

    this.carousel.on('select', this.onSelect.bind(this));
    this.$nextButton.addEventListener('click', this.onNext.bind(this));
    this.$previousButton.addEventListener('click', this.onPrev.bind(this));

    this.$yearsButtons.forEach(($button, index) => {
      $button.addEventListener('click', this.onYearClick.bind(this, $button, index))
    });
  }

  onSelect() {
    this.clearAllYears();
    this.$yearsButtons[this.carousel.selectedIndex].classList.add('is-active');
    this.$yearMobile.innerHTML = this.carousel.selectedElement.dataset.year;
  }

  onNext() {
    this.carousel.next();
  }

  onPrev() {
    this.carousel.previous();
  }

  clearAllYears() {
    this.$yearsButtons.forEach($year => $year.classList.remove('is-active'));
  }

  onYearClick($button, index) {
    this.clearAllYears();
    this.carousel.select(index);
  }
}
